import { Trash2 } from "lucide-react";

import { Button } from "@/components/button";
import { Dialog, DialogCloseButton, DialogTitle } from "@/components/dialog";
import { Modal } from "@/components/modal";

import type { SizeItem } from "./size-presets";

type RemoveSizeDialogProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onOpenChange: (isOpen: boolean) => void;
  size?: SizeItem;
};

export function RemoveSizeDialog({
  isOpen,
  onConfirm,
  onOpenChange,
  size,
}: RemoveSizeDialogProps) {
  return (
    <Modal
      classNames={{ modal: "w-[400px] max-w-[calc(100vw-32px)]" }}
      isDismissable
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog alert className="p-6">
        <DialogCloseButton />

        <span className="flex size-11 items-center justify-center rounded-full bg-utility-error-50 text-text-error-primary">
          <Trash2 className="size-5" />
        </span>

        <DialogTitle className="mt-4 text-lg font-semibold text-text-primary">
          Remove this size?
        </DialogTitle>
        <p className="mt-1 text-sm text-text-tertiary">
          {size ? (
            <>
              <span className="break-all font-medium text-text-secondary">
                {size.label} {size.size}
              </span>{" "}
              will be removed, but you can create it again anytime.
            </>
          ) : (
            "This deliverable will be removed, but you can create it again anytime."
          )}
        </p>

        <div className="mt-6 flex justify-end gap-3">
          <Button
            className="flex-1"
            onPress={() => onOpenChange(false)}
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            className="flex-1"
            color="destructive"
            onPress={() => {
              onConfirm();
              onOpenChange(false);
            }}
            variant="primary"
          >
            Delete
          </Button>
        </div>
      </Dialog>
    </Modal>
  );
}
